// eslint-disable-next-line import/prefer-default-export
export enum EOnboardingStepFriendlyNames {
  basicInfo = 'Basic Info',
  creatingLibby = 'Creating Libby',
  tryItOut = 'Try It Out',
}
